export const weeklyScheduleEvents = {
  weekDetailViewed: "week detail viewed",
  weekDetailPageCourseFiltered: "week detail page course filtered",
  noSchedulePageViewed: "no schedule page viewed",
  weekDetailPageBackToLiveClassButtonClicked:
    "week detail page back to Live Class button clicked",
  weekDetailPageSeeClassMaterialClicked:
    "week detail page see class material clicked",
  weekDetailClosed: "week detail closed"
};
